import { map as rxjsmap } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { BaseServices } from './../../kuba.services';
import {
  HttpClient,
  HttpContext,
  HttpHeaderResponse,
  HttpParams
} from '@angular/common/http';
import { SKIP_ERROR_TOAST } from '../../../shared/http-context-tokens';
import { map } from 'rxjs/internal/operators/map';
import { PagedResponse } from '../../shared/models/pagedResponse';
import { PaginationRequest } from '../../shared/models/paginationRequest';
import { DeviationFilterDto } from '../models/deviationFilterRequest';
import { DeviationListDto } from '../models/deviationListDto';
import { DeviationSubModule } from '../models/deviationSubModule';
import { MultiDeleteResultDto } from '../models/activities';
import {
  DeviationQrCaseType,
  DeviationQrCodeCreateDto,
  DeviationQrCodeDto,
  DeviationQrCodeListItem
} from '../models/deviationQrCodeDto';
import { CreateDeviationRequestDto } from '../../deviation/models/createDeviationRequest';

@Injectable()
export class DeviationServices {
  _caseType: Observable<any> = null!;
  constructor(private http: HttpClient) {}

  clearCachedCaseType() {
    this._caseType = null!;
  }

  /**
   * Validates and adds sorting parameters to HttpParams
   * @param params - Existing HttpParams
   * @param request - PaginationRequest containing sort info
   * @returns Updated HttpParams with sorting parameters
   */
  private addSortingParams(
    params: HttpParams,
    request: PaginationRequest
  ): HttpParams {
    let updatedParams = params;

    if (request.sortColumn) {
      updatedParams = updatedParams.set('sortColumn', request.sortColumn);
    }
    if (request.sortDirection) {
      updatedParams = updatedParams.set('sortDirection', request.sortDirection);
    }

    return updatedParams;
  }

  /**
   * Adds filter parameters to HttpParams
   * @param params - Existing HttpParams
   * @param filter - DeviationFilterDto containing filter values
   * @returns Updated HttpParams with filter parameters
   */
  private addFilterParams(
    params: HttpParams,
    filter?: DeviationFilterDto
  ): HttpParams {
    let updatedParams = params;

    if (filter) {
      Object.keys(filter).forEach(key => {
        const value = filter[key as keyof DeviationFilterDto];
        if (value !== undefined && value !== null && value !== '') {
          updatedParams = updatedParams.set(key, value.toString());
        }
      });
    }

    return updatedParams;
  }

  // bind the type of case
  getAllCaseType() {
    return this.http
      .get(
        environment.BASE_URL +
          '/casetypes/' +
          BaseServices.BusinessId +
          '/' +
          BaseServices.roleId
      ).pipe(rxjsmap((result: any) => result));
  }

  getAllCaseTypeByBusinessId(businessId: number) {
    return this.http
      .get(environment.BASE_URL + '/casetypes/' + businessId)
      .pipe(map((result: any) => result));
  }

  getClients(id: number) {
    return this.http
      .get(environment.BASE_URL + '/client/getall/' + id).pipe(rxjsmap((result: any) => result));
  }
  getDeviationsByUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviationbyuser/' + id).pipe(rxjsmap((result: any) => result));
  }

  getModulesByDeviation(businessId: number): Observable<DeviationSubModule[]> {
    return this.http.get<DeviationSubModule[]>(
      `${environment.BASE_URL}/deviation/submodules/${businessId}`
    );
  }

  getDeviationsByUserPaged(
    userId: number,
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/deviationbyuserpaged/${userId}`,
      { params }
    );
  }

  /**
   * Retrieves the dropdown options for deviation modules based on the business ID
   * @param businessId - The ID of the business to retrieve modules for
   * @returns List of dropdown options
   */
  getModuleDropdown(businessId: number) {
    return this.http
      .get(environment.BASE_URL + '/deviation/moduleobjects/' + businessId).pipe(rxjsmap((result: any) => result));
  }

  createDeviation(request: CreateDeviationRequestDto) {
    return this.http
      .post(`${environment.BASE_URL_V2}/kuba/v2/deviationwrite`, request).pipe(rxjsmap((response: any) => response));
  }

  getAllTopics(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/DeviationTopic/' + Id).pipe(rxjsmap((result: any) => result));
  }
  getTopicsForAdmin(riskId: number) {
    return this.http
      .get(environment.BASE_URL + '/topicsforadmin/' + riskId).pipe(rxjsmap((result: any) => result));
  }
  getDepartmentsForAdmin(riskId: number) {
    return this.http
      .get(environment.BASE_URL + '/departmentforadmin/' + riskId).pipe(rxjsmap((result: any) => result));
  }
  // add the type case
  addTypeCase(data: any) {
    return this.http
      .post(environment.BASE_URL + '/CaseType', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // add  the department
  addDepartment(data: any) {
    return this.http
      .post(environment.BASE_URL + '/department', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // update  the department
  updateDepartment(Id: number, data: any) {
    return this.http
      .put(environment.BASE_URL + '/department/' + Id, data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // delete  the department
  deleteDepartment(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/departmentdelete/' + Id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // update the typecase
  updateCaseType(Id: number, data: any) {
    return this.http
      .put(environment.BASE_URL + '/CaseType/' + Id, data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // delete the typecase
  deleteTypeCase(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/CaseType/' + Id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // delete the topics
  deleteTopics(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/Delete/' + Id).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // add the topics
  addTopics(data: any) {
    return this.http
      .post(environment.BASE_URL + '/Save', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // update the topics
  updateTopics(data: any) {
    return this.http
      .put(environment.BASE_URL + '/Update', data).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  deleteDeviation(id: any) {
    return this.http
      .delete(environment.BASE_URL + '/deviation/' + id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }

  /**
   * Delete multiple deviations
   * @param deviationIds - Array of deviation IDs to delete
   * @returns Observable with deletion result
   */
  multiDeleteDeviations(
    deviationIds: number[]
  ): Observable<MultiDeleteResultDto> {
    return this.http.delete<MultiDeleteResultDto>(
      `${environment.BASE_URL}/deviations/multidelete`,
      {
        body: deviationIds
      }
    );
  }

  getUser(id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/ContactLookup/' + id).pipe(rxjsmap((result: any) => result));
  }
  getDeviationByBusiness(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviationslist/' + id).pipe(rxjsmap((result: any) => result));
  }
  getDeviationByPortal(portalId: number) {
    return this.http
      .get(environment.BASE_URL + '/portaldeviationslist/' + portalId).pipe(rxjsmap((result: any) => result));
  }
  getDeviationByAdmin(portalId: number) {
    return this.http
      .get(environment.BASE_URL + '/admindeviationslist/' + portalId).pipe(rxjsmap((result: any) => result));
  }
  getFeatureByBusiness(id: number): Observable<string> {
    return this.http.get<string>(`${environment.BASE_URL}/featurelist/${id}`);
  }
  // bind business dropdown
  getBusiness() {
    // Use pagination with large page size to get all businesses
    const filter = {
      PageNumber: 1,
      PageSize: 10000, // Large number to get all businesses
      SortColumn: 'CompanyName',
      SortDirection: 'ASC'
    };

    return this.http
      .post<any>(environment.BASE_URL + '/businesses/paged', filter)
      .pipe(map((result: any) => result.Items || []));
  }
  // bind deviation list
  getDeviationListWithDateFilter(startDate: string, endDate: string) {
    return this.http
      .get(`${environment.BASE_URL}/deviations/${startDate}/${endDate}`).pipe(rxjsmap(result => result));
  }
  getAllDeviationByDepartment(userId: any) {
    return this.http
      .get(`${environment.BASE_URL}/deviationbydepartment/${userId}`).pipe(rxjsmap(result => result));
  }

  getAllDeviationByDepartmentPaged(
    userId: any,
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/deviationbydepartmentpaged/${userId}`,
      { params }
    );
  }

  saveDocument(document: any) {
    return this.http
      .post(
        environment.BASE_URL + '/file/upload/business/followup/deviation-docs',
        document
      ).pipe(rxjsmap(result => result));
  }

  getById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/deviation/' + id).pipe(rxjsmap(result => result));
  }

  getDeviationListPagedAdmin(
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/deviationslistpagedadmin`,
      { params }
    );
  }

  getDeviationListPagedByBusinessId(
    applicationId: number,
    request: PaginationRequest,
    businessId?: number,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('applicationId', applicationId.toString())
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    if (businessId) {
      params = params.set('businessId', businessId.toString());
    }

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    const url = businessId
      ? `${environment.BASE_URL}/deviationslistpaged/${businessId}`
      : `${environment.BASE_URL}/deviationslistpaged/0`;

    return this.http.get<PagedResponse<DeviationListDto>>(url, { params });
  }

  portalDeviationPagedList(
    portalId: number,
    userId: number,
    isPortalManager: boolean,
    applicationId: number,
    request: PaginationRequest,
    deviationFilterDto?: DeviationFilterDto
  ): Observable<PagedResponse<DeviationListDto>> {
    let params = new HttpParams()
      .set('portalId', portalId.toString())
      .set('userId', userId.toString())
      .set('isPortalManager', isPortalManager.toString())
      .set('applicationId', applicationId.toString())
      .set('pageNumber', request.pageNumber.toString())
      .set('pageSize', request.pageSize.toString());

    params = this.addSortingParams(params, request);

    params = this.addFilterParams(params, deviationFilterDto);

    return this.http.get<PagedResponse<DeviationListDto>>(
      `${environment.BASE_URL}/portaldeviationslistpaged/${portalId}`,
      { params }
    );
  }

  getRModeFeature() {
    return this.http
      .get<HttpHeaderResponse>(
        environment.BASE_URL + '/rmode-feature/' + BaseServices.BusinessId
      )
      .pipe(
        map((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  /**
   * The business's deviation QR codes: the business-wide row first, then one row per active department.
   */
  getDeviationQrCodes(): Observable<DeviationQrCodeListItem[]> {
    return this.http.get<DeviationQrCodeListItem[]>(
      `${environment.BASE_URL_V2}/deviation/qr-code/${BaseServices.BusinessId}/list`
    );
  }

  /**
   * Creates a QR code for the whole business, or for one department when its id is given
   * @param businessDepartmentId The department, or null for the business-wide code
   * @param expiresOn Last day the code works as yyyy-MM-dd, or null for no expiration
   */
  createDeviationQrCode(
    businessDepartmentId: number | null,
    expiresOn: string | null
  ): Observable<DeviationQrCodeDto> {
    const payload: DeviationQrCodeCreateDto = {
      BusinessId: BaseServices.BusinessId,
      ExpiresOn: expiresOn ?? undefined
    };
    const url =
      businessDepartmentId === null
        ? `${environment.BASE_URL_V2}/deviation/qr-code`
        : `${environment.BASE_URL_V2}/deviation/qr-code/departments/${businessDepartmentId}`;

    return this.http.post<DeviationQrCodeDto>(url, payload);
  }

  /**
   * Revokes the business-wide code, or one department's code when its id is given. The other codes
   * keep working.
   * @param businessDepartmentId The department, or null for the business-wide code
   */
  revokeDeviationQrCode(businessDepartmentId: number | null): Observable<void> {
    const base = `${environment.BASE_URL_V2}/deviation/qr-code/${BaseServices.BusinessId}`;
    const url = businessDepartmentId === null ? base : `${base}/departments/${businessDepartmentId}`;

    return this.http.delete<void>(url);
  }

  /** The business's active case types, with whether the anonymous QR form offers each. */
  getDeviationQrCaseTypes(): Observable<DeviationQrCaseType[]> {
    return this.http.get<DeviationQrCaseType[]>(
      `${environment.BASE_URL_V2}/deviation/qr-code/${BaseServices.BusinessId}/case-types`
    );
  }

  /** Shows or hides a case type on the anonymous QR form. */
  setDeviationQrCaseTypeVisibility(caseTypeId: number, isPublic: boolean): Observable<void> {
    return this.http.put<void>(
      `${environment.BASE_URL_V2}/deviation/qr-code/${BaseServices.BusinessId}/case-types/${caseTypeId}`,
      { IsPublic: isPublic }
    );
  }

  /**
   * The id of the system user every QR deviation is created by, to mark and filter them in the list.
   * A failure is not shown: the list then simply has no QR markers.
   */
  getDeviationQrSourceUser(): Observable<number> {
    return this.http.get<number>(`${environment.BASE_URL_V2}/deviation/qr-code/source-user`, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true)
    });
  }

  /**
   * Clear cached topics
   */
  clearCachedTopic() {}
}
